var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Duplicate2 = function Duplicate2(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 15 15' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'Page 1'
      ),
      React.createElement('path', { d: 'M7 4h5V3H7v1zm7 5.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v8zm-4 4a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5H4v4.5c0 .827.673 1.5 1.5 1.5H10v2.5zM13.5 0h-8C4.673 0 4 .673 4 1.5V4H1.5C.673 4 0 4.673 0 5.5v8c0 .827.673 1.5 1.5 1.5h8c.827 0 1.5-.673 1.5-1.5V11h2.5c.827 0 1.5-.673 1.5-1.5v-8c0-.827-.673-1.5-1.5-1.5zM7 7h5V6H7v1z',
        fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Duplicate2;
//# sourceMappingURL=Duplicate2.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Duplicate2.js